import React from "react";

const process = [
  "Understanding your business goals",
  "Planning app features and user journeys",
  "Designing the interface",
  "Developing the application",
  "Testing performance and security",
  "Launching on Google Play and Apple App Store",
  "Providing ongoing support and updates",
];

export default function Section3() {
  return (
    <div className="w-full Section3 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section3-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          What Does a Mobile App Development Company Do?
        </h2>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-6">
          A mobile app development company turns your business idea into a
          working application that customers can use on their smartphones.
        </p>

        <p className="text-center font-bold text-[#151515] text-sm md:text-base font-open mb-5">
          The process includes:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 mb-8">
          {process.map((item, index) => (
            <div
              key={item}
              className="bg-white rounded-[6px] p-4 flex items-start gap-3 font-open"
            >
              <span className="shrink-0 w-[26px] h-[26px] rounded-full bg-[#cd2122] text-white text-xs font-bold flex items-center justify-center">
                {index + 1}
              </span>
              <p className="text-xs md:text-sm text-[#535353] leading-[18px]">{item}</p>
            </div>
          ))}
        </div>

        <div className="w-full md:w-[85%] mx-auto text-left leading-[22px] text-[#535353] text-sm md:text-base font-open space-y-4">
          <p>
            At Mean3, we handle the complete mobile app development process
            under one team. Our developers, designers, and project managers
            work together to create apps that are fast, secure, and easy to
            scale.
          </p>
          <p>
            Businesses in the UAE need more than just a basic app. Customers
            expect smooth experiences, Arabic language support, secure
            payment options, and applications that perform well across
            different devices. That is why choosing a mobile app development
            company in Dubai, Abu Dhabi, Sharjah, or anywhere in the UAE that
            understands the local market is important.
          </p>
        </div>
      </div>
    </div>
  );
}